import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { Row, Col, Button } from 'reactstrap'

import ReactSelect from '../../../CustomReactSelectComponent'
import CustomTextarea from '../../../CustomTextarea'
import { setIGiveUp } from '../../../../modules/Contacts/redux/ContactActions'

const GiveUpModal = (props) => {
  const dispatch = useDispatch()
  const errors = useSelector((state) => state.errors)
  const [giveUpData, setGiveUpData] = useState({})
  const [displayNote, setDisplayNote] = useState(false)
  const [options, setOptions] = useState([])

  useEffect(() => {
    getOptions()
  }, [])

  const getOptions = async () => {
    const responseOptions = await axios.get(`/support-tables`, {
      params: { tableFilter: { support_type_id: 28 } },
    })
    const newOptions = []
    responseOptions.data.data.forEach((option) => {
      newOptions.push({
        id: option.id,
        name: option.name,
      })
    })
    setOptions(newOptions)
  }

  const handleChangeSelect = (value) => {
    if (value && value.name === 'Other') {
      setDisplayNote(true)
    } else setDisplayNote(false)
    setGiveUpData({
      ...giveUpData,
      giveUpReason: value ? value.id : null,
    })
  }

  const onChangeReason = (e) => {
    setGiveUpData({
      ...giveUpData,
      otherReasonNote: e.target.value,
    })
  }

  const onSave = () => {
    dispatch(setIGiveUp(giveUpData, displayNote))
  }

  return (
    <>
      <Row>
        <Col>
          <ReactSelect
            options={options}
            defaultValue={giveUpData.giveUpReason || null}
            onChange={handleChangeSelect}
            isClearable={true}
            isMulti={false}
            label='Give Up Reason'
            placeholder='Please Select...'
            invalid={!!errors.giveUpReason}
            errorMess={errors.giveUpReason && errors.giveUpReason}
          />
        </Col>
      </Row>
      <Row className='mt-3' style={{ visibility: displayNote ? 'visible' : 'hidden' }}>
        <Col>
          <CustomTextarea
            label='Other Reason (please specify)'
            rows={3}
            onChange={onChangeReason}
            value={giveUpData.otherReasonNote}
            placeholder='Other Reason...'
            invalid={!!errors.otherReasonNote}
            errorMess={errors.otherReasonNote && errors.otherReasonNote}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col className='d-flex justify-content-end'>
          <Button size='sm' className='gold-color-button mr-2' onClick={onSave}>
            Save
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default GiveUpModal
